export default [
  {
    path: '/active-gradereport-fujian/index',
    name: 'index',
    component: () => import('@/views/active-gradereport-fujian/index'),
    meta: {
      title: '福建省质检成绩分析报告'
    }
  },
  {
    path: '/active-gradereport-fujian/my-list',
    name: 'my-list',
    component: () => import('@/views/active-gradereport-fujian/my-list'),
    meta: {
      title: '福建省质检成绩分析报告'
    }
  },{
    path: '/active-gradereport-fujian/buy-record',
    name: 'buy-record',
    component: () => import('@/views/active-gradereport-fujian/buy-record'),
    meta: {
      title: '购买记录'
    }
  },{
    path: '/active-gradereport-fujian/about-our',
    name: 'about-our',
    component: () => import('@/views/active-gradereport-fujian/about-our'),
    meta: {
      title: '关于我们'
    }
  },{
    path: '/active-gradereport-fujian/msg-input',
    name: 'msg-input',
    component: () => import('@/views/active-gradereport-fujian/msg-input'),
    meta: {
      title: '信息填写'
    }
  },{
    path: '/active-gradereport-fujian/first-msg',
    name: 'first-msg',
    component: () => import('@/views/active-gradereport-fujian/first-msg'),
    meta: {
      title: '信息填写'
    }
  },{
    path: '/active-gradereport-fujian/grade-report',
    name: 'grade-report',
    component: () => import('@/views/active-gradereport-fujian/grade-report'),
    meta: {
      title: '成绩报告'
    }
  },{
    path: '/active-gradereport-fujian/pay',
    name: 'pay',
    component: () => import('@/views/active-gradereport-fujian/pay'),
    meta: {
      title: '支付'
    }
  },{
    path: '/active-gradereport-fujian/batch',
    name: 'batch',
    component: () => import('@/views/active-gradereport-fujian/batch'),
    meta: {
      title: '查批次'
    }
  },{
    path: '/active-gradereport-fujian/oneline',
    name: 'oneline',
    component: () => import('@/views/active-gradereport-fujian/oneline'),
    meta: {
      title: '一分一段'
    }
  },{
    path: '/active-gradereport-fujian/agreement',
    name: 'agreement',
    component: () => import('@/views/active-gradereport-fujian/agreement'),
    meta: {
      title: '协议内容'
    }
  },{
    path: '/active-gradereport-fujian/paySuccess',
    name: 'paySuccess',
    component: () => import('@/views/active-gradereport-fujian/paySuccess'),
    meta: {
      title: '支付成功'
    }
  }
]
